import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import { useState } from "react";
import ServiceCenterSearch from "./offices/ServiceCenterSearch";
import FAQSection from "./faqs/FAQSection";
import FAQSearch from "./faqs/FAQSearch";
import { useTranslation } from "react-i18next";

const FaqsTabContent = () => {
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <div className="space-y-6">
      <FAQSearch onSearch={setSearchQuery} />
      <FAQSection searchQuery={searchQuery} />
    </div>
  );
};

export const SupportCenterLanding=()=>{
     const { t } = useTranslation();
     const tabComponents = {

    offices: {
      label: t("Offices"),
      shortLabel: t("Offices"),
      component: <ServiceCenterSearch />
    },
    faqs: {
      label: t("FAQs"),
      shortLabel: t("FAQs"),
      component: <FaqsTabContent />
    },  
  };

  const urlMapping = {
    offices: "offices",
    faqs: "faqs", 
  };

     return (
 <div className="p-6 space-y-6">
  <PageHeader title={t("Support Center")} subtitle={t("Find answers to your questions or locate our offices")}
  ></PageHeader>
 <Tabs 
        defaultValue="offices"
        tabComponents={tabComponents}
        urlMapping={urlMapping}
        tabsListClassName="grid grid-cols-2 w-full"
        idPrefix="offices-tab"
        className="space-y-4"
      />
  </div>
 );
}